import { render, staticRenderFns } from "./MasterBank.vue?vue&type=template&id=e15b8f30&"
import script from "./MasterBank.vue?vue&type=script&lang=js&"
export * from "./MasterBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports